"use client";

import { ComponentPropsWithoutRef, ReactNode } from "react";

import { env } from "@saas/config/shared/env/env";
import { useFlagStatus } from "@saas/flags/feature/@hook/flag-status/use-flag-status";
import { SVG } from "@saas/shared/icon";
import { Logo } from "@saas/shared/ui/logo/logo";
import { classNames } from "@saas/shared/utils/class-names/class-names";
import { useScrollDirection } from "@saas/shared/utils/hook/use-scroll-direction/use-scroll-direction";

export type MenuItem = {
  icon?: SVG;
  label: string;
  url: string;
  testid?: string;
};

export type HeaderMenu = {
  label: string;
  testid?: string;
  url?: string;
  enabled?: boolean;
  child?: MenuItem[];
};

export interface HeaderProps {
  leftNavBar?: ReactNode;
  rightNavBar?: ReactNode;
  sticky?: boolean;
  transparent?: boolean;
  whiteMenu?: boolean;
  testid?: string;
}

export const Header = ({
  leftNavBar,
  rightNavBar,
  sticky,
  transparent,
  whiteMenu,
  testid,
}: HeaderProps) => {
  const scrollDirection = useScrollDirection();
  const isAccountRelease = useFlagStatus("account");

  return (
    <div
      className={classNames(
        "top-0 z-20 w-full overflow-visible",
        sticky ? "sticky" : "relative"
      )}
      data-testid={testid}
    >
      <div
        className={classNames(
          "top-0 z-10 flex w-full items-center justify-between px-5 py-4 drop-shadow transition-all duration-300 lg:px-6 lg:py-1",
          transparent ? "bg-transparent" : "bg-white",
          scrollDirection ? null : "!bg-white"
        )}
        data-testid={testid + "__container"}
      >
        <div className={"flex items-center lg:gap-20"}>
          <AppLogo variant={whiteMenu && scrollDirection ? "white" : "color"} />

          {leftNavBar}
        </div>

        {isAccountRelease ? rightNavBar : null}
      </div>
    </div>
  );
};

const AppLogo = ({ variant }: ComponentPropsWithoutRef<typeof Logo>) => (
  <a
    href={env.LANDING_URL}
    className={"cursor-pointer"}
    data-testid={"landing__logo__melaka"}
  >
    <Logo className={"h-7 w-full md:h-full"} variant={variant} />
  </a>
);

export default Header;
